import { FC } from 'react';
import { ButtonDisabledStyle, ButtonVariant } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { configVars } from 'src/helpers';
import { StyledButton } from './styles';

export interface ButtonDownloadFilesProps {
  applicantId?: string;
  fileName: string;
  isDisabled: boolean;
  className?: string;
}

const ButtonDownloadFiles: FC<ButtonDownloadFilesProps> = (props) => {
  const { isDisabled, fileName, className, applicantId } = props;

  const onClick = () => {
    if (isDisabled) {
      return;
    }
    window.location.href = `${configVars.epa_url}/applicants/${applicantId}/documents.zip`;
  };

  return (
    <StyledButton
      name={`download_files_${fileName}_button`}
      isDisabled={isDisabled}
      onClick={onClick}
      variant={ButtonVariant.ghost}
      disabledStyle={ButtonDisabledStyle.transparent}
      className={className}
    >
      <Icon icon="download-icon" color="blue700" />
    </StyledButton>
  );
};

export default ButtonDownloadFiles;
